import { ReactElement, ReactNode } from 'react'

import { Direction, Droppable } from '@hello-pangea/dnd'

interface Props {
    children: ReactNode
    droppableId: string
    direction?: Direction
}

const DroppableList = ({
    children,
    droppableId,
    direction,
}: Props): ReactElement => (
    <Droppable droppableId={droppableId} direction={direction}>
        {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
                {children}
                {provided.placeholder}
            </div>
        )}
    </Droppable>
)

export default DroppableList
